/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import LanguageListItem from './locale-list-item';
import { connect } from 'react-redux';
import Velocity from 'velocity-animate';
import ArrowDown from '../../../components/svg/arrow-down';

export class LocalePicker extends React.Component {

  static propTypes = {
    locales: PropTypes.array.isRequired,
    selectedLocale: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      menuOpen: false
    };

    this.handleMenuToggle = this.handleMenuToggle.bind(this);
  }

  handleMenuToggle () {
    this.setState({
      menuOpen: !this.state.menuOpen
    }, () => {
      if (this.state.menuOpen) {
        Velocity(this.refs.menu, 'slideDown', {duration: 200});
      } else {
        Velocity(this.refs.menu, 'slideUp', {duration: 200});
      }
    });
  }

  render () {
    let selectedLanguageClassNames = 'sprite-image flag flag-' + this.props.selectedLocale;

    return (
      <ul className='select-list lang-menu hide-tablet' role='menu' onClick={this.handleMenuToggle}>
        <li>
          <span className='selected'>
            <span className={selectedLanguageClassNames}/>
            <span className="ml-10"><ArrowDown width='15px' height='10px' color='blue-light' /></span>
          </span>

          <ul className='select-list-sub' role='menu' aria-hidden='true' ref='menu'>
            {this.props.locales.map((locale) =>
              <LanguageListItem lang={locale} key={locale}/>
            )}
          </ul>
        </li>
      </ul>
    );
  }
}

function mapStateToProps (state) {
  return {
    selectedLocale: state.i18n.locale
  };
}

export default connect(mapStateToProps)(LocalePicker);



/** WEBPACK FOOTER **
 ** ./src/components/header/locale-picker/locale-picker.js
 **/